import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '@/layouts';
import { VStack, HStack } from '@/components/core';
import { Clock, Mail, CheckCircle, ArrowRight } from 'lucide-react';

export default function BillingPending() {
  const { t } = useTranslation('billing');
  const navigate = useNavigate();

  return (
    <AuthLayout
      showBranding={false}
      maxWidth="md"
      className="design-page-gradient"
    >
      <VStack gap="xl" align="center" className="text-center">
        {/* Icon */}
        <div
          className="flex h-20 w-20 items-center justify-center rounded-full"
          style={{ backgroundColor: 'var(--color-warning-bg)' }}
        >
          <Clock
            className="h-10 w-10"
            style={{ color: 'var(--color-warning)' }}
          />
        </div>

        {/* Title */}
        <VStack gap="sm" align="center">
          <h1
            className="text-2xl font-bold"
            style={{ color: 'var(--color-primary-text)' }}
          >
            {t('pending.title')}
          </h1>
          <p className="text-muted-foreground">
            {t('pending.subtitle')}
          </p>
        </VStack>

        {/* Info Card */}
        <div
          className="w-full rounded-token-card p-token-lg"
          style={{
            backgroundColor: 'var(--color-glass-background)',
            border: '1px solid var(--color-glass-border)',
          }}
        >
          <VStack gap="md">
            <HStack gap="sm" align="start">
              <Mail
                className="mt-1 h-5 w-5 flex-shrink-0"
                style={{ color: 'var(--color-primary-button)' }}
              />
              <p className="text-left text-sm text-muted-foreground">
                {t('pending.emailNotice')}
              </p>
            </HStack>

            <HStack gap="sm" align="start">
              <CheckCircle
                className="mt-1 h-5 w-5 flex-shrink-0"
                style={{ color: 'var(--color-success)' }}
              />
              <p className="text-left text-sm text-muted-foreground">
                {t('pending.creditNotice')}
              </p>
            </HStack>
          </VStack>
        </div>

        {/* Processing Time Info */}
        <p
          className="text-xs"
          style={{ color: 'var(--color-secondary-text)' }}
        >
          {t('pending.processingTime')}
        </p>

        {/* Action Button */}
        <button
          onClick={() => navigate('/shop')}
          className="flex items-center gap-2 rounded-token-button px-token-lg py-token-sm transition-colors"
          style={{
            backgroundColor: 'var(--color-primary-button)',
            color: 'white',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--color-primary-button-hover)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--color-primary-button)';
          }}
        >
          {t('pending.continueShopping')}
          <ArrowRight className="h-4 w-4" />
        </button>
      </VStack>
    </AuthLayout>
  );
}
